(function ($) {
	'use strict';

	// Free trial items
	$(document).ready(function () {
		if (jQuery(window).width() < 768) {
			jQuery('.free-trials__row').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				centerMode: true,
				centerPadding: '150px',
				rows: 0,
				responsive: [
					{
						breakpoint: 480,
						settings: {
							centerPadding: '130px',
						}
					},
					{
						breakpoint: 400,
						settings: {
							centerPadding: '80px',
						}
					}
				]
			}).on('setPosition', function (event, slick) {
				slick.$slides.css('height', slick.$slideTrack.height() + 'px');
			});
		}
	});
})(jQuery);